const fontSizesTheme = {
  xs: ".6rem",
  sm: ".65rem",
  md: ".8rem",
  lg: "1.2rem",
  xl: "1.5rem",
};

export default fontSizesTheme;
